import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { IconButton, InputAdornment, InputBase } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { theme } from 'theme';

import SearchIcon from '@material-ui/icons/Search';

const CustomInput = withStyles({
  root: {
    color: `${theme.colors.primary.black}`,
    borderBottom: `2px solid ${theme.colors.primary.black}`,
    fontSize: 20,
  },
})(InputBase);
/* eslint-disable */
export const FilterSearchBar = forwardRef(
  ({ customOnChange, customOnClick, label }, ref) => {
    useImperativeHandle(ref, () => ({
      customReset() {
        setValue('');
      },
      setInitialValue(value) {
        setValue(value);
      },
    }));

    const [value, setValue] = useState('');
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
      if (!isDirty) setIsDirty(true);
    }, []);

    useEffect(() => {
      if (isDirty) customOnChange && customOnChange(value);
    }, [value]);

    return (
      <CustomInput
        fullWidth
        type="text"
        placeholder={label}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={customOnClick && customOnClick}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              disableFocusRipple
              disableTouchRipple
              disableRipple
              onClick={customOnClick && customOnClick}
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    );
  }
);
/* eslint-enabled */
